import styled from 'styled-components';

import { StyleSummary, StylePrice } from '../Summary/style';
import { fontSize, colors } from '../../styles/variables';

/**
 * Formata o Container do Resumo
 * @extends {StyleSummary}
 */

export const Summary = styled(StyleSummary)`
  // max-width: 30%;

  ul > li > span {
    display: flex;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }

.pix-suggestion {
  display: flex;
  gap: 0.2vw;
  margin: 12px 0;
  padding: 10px 12px;
  background: #e8f5e9;
  border-left: 3px solid #2e7d32;
  border-radius: 4px;
  color: #1b5e20;
  font-size: 0.9em;
  text-align: center;
  
  strong {
    color: #2e7d32;
  }
  
  .suggestion-text {
    display: inline;
  }
}

.pix-cupom-warning {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 12px 0;
  padding: 10px 12px;
  background: #fff8e1;
  border-left: 3px solid #f57c00;
  border-radius: 4px;
  color: #6d4c00;
  font-size: 0.85em;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
    fill: #f57c00;
    margin-top: 2px;
  }

  .warning-text {
    display: block;       /* anula qualquer flex herdado */
    flex: 1;              /* ocupa o espaço restante */
    min-width: 0;         /* permite quebra natural de texto */
  }

  strong {
    display: inline;      /* garante que strong não vire bloco */
  }
}
`;

/**
 * Formata o bloco do total no Resumo
 * @extends {StylePrice}
 * Herda estilo para formatar o interior do Container
 * @extends {fontSize}
 */
export const Price = styled(StylePrice)`
  span {
    font-size: ${fontSize.lg};
  }
`;

export const Deadline = styled(StyleSummary)`
  padding: 0.5rem 0;

  span {
    font-weight: 700;
    color: ${colors.primary};
    text-transform: none;
  }
`
